import React, { ReactNode, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { fetchPacienteAuthData } from "../authActions";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { pacienteId, isLoading } = useAppSelector((state) => state.auth);
  const hasFetched = useRef(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    // Si no hay tokens, redirigir al login
    if (!accessToken && !refreshToken) {
      window.location.href = "https://login.intranetsonrie.site";
      return;
    }

    // Evitar llamadas repetidas: solo llamar si no se ha intentado cargar antes
    if (!pacienteId && !isLoading && accessToken && !hasFetched.current) {
      hasFetched.current = true;
      dispatch(fetchPacienteAuthData());
    }
  }, [dispatch, pacienteId, isLoading]);

  return <>{children}</>;
};

export default ProtectedRoute;
